<template>
  <UFooter
    class="bg-slate-100 dark:bg-gray-900 text-sm xl:text-md text-muted py-6 border-t border-gray-300 dark:border-t-gray-800 mt-16"
  >
    <template #left>
      <div>
        <ul class="text-center lg:text-right">
          <li class="mb-1.5">A side project by:</li>
          <li>Code Collective ApS (DK43805150)</li>
          <li>Njalsgade 76, Copenhagen, Denmark</li>
        </ul>
      </div>
    </template>
    <template #right>
      <ul class="text-center lg:text-right">
        <li class="">
          <NuxtLink class="underline underline-offset-2" to="/get-in-touch">
            Get in touch
          </NuxtLink>
        </li>
        <li class="mb-1.5">
          <NuxtLink class="underline underline-offset-2" to="/give-feedback">
            Give feedback
          </NuxtLink>
        </li>
        <li class="">Timeplat.eu &copy; {{ new Date().getFullYear() }}</li>
      </ul>
    </template>
  </UFooter>
</template>
